<template>
  <div>
    <div class="honorTimeB">
      <div class="item_name">
        <span v-if="lang == 'en'">{{ en_name }}</span>
        <span v-else>{{ item_name }}</span>
      </div>
      <ul class="slides">
        <li :key="subIdx" v-for="(subItem, subIdx) in AwardsInfos.slice(0,3)"  v-show="!showAll">
          <div class="item flex-cb">
            <div class="item_left">
              <div class="tit">{{ subItem.Date }}</div>
              <div class="desc">{{ subItem.Name }}</div>
            </div>
            <div class="item_link" @click="showImg(true, subItem.Url)">
              <span v-if="lang == 'zh'">查看奖状</span>
              <span v-else>Certificate</span>
            </div>
          </div>
        </li>

        <li :key="subIdx2" v-for="(subItem, subIdx2) in AwardsInfos"  v-show="showAll">
          <div class="item flex-cb">
            <div class="item_left">
              <div class="tit">{{ subItem.Date }}</div>
              <div class="desc">{{ subItem.Name }}</div>
            </div>
            <div class="item_link" @click="showImg(true, subItem.Url)">
              <span v-if="lang == 'zh'">查看奖状</span>
              <span v-else>Certificate</span>
            </div>
          </div>
        </li>
      </ul>

      <a href="javascript:;" class="btn-loadmore" @click="toggleLoadMore" v-if="this.AwardsInfos.length>3">
        <span v-if="!showAll">展开更多</span>
        <span v-else>收起</span>
        <i class="el-icon-arrow-down" v-if="!showAll"></i>
        <i class="el-icon-arrow-up" v-else></i>
      </a>
    </div>
    <div class="imgMask" v-if="showHonor" @click="showImg(false)">
      <div class="imgBig">
        <div class="imgBbox">
          <el-image class="imgIner" :src="imgUrl" fit="contain"></el-image>
          <i class="el-icon-error"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { judgeWindow } from "@/utils/tool.js";

export default {
  data() {
    return {
      lang: this.$global.lang,
      showHonor: false,
      num: 0,
      item_name: "国家级荣誉",
      en_name: "National Honors",
      
    };
  },
  props: ["AwardsInfos", "dom","showAll"],
  methods: {
    showImg(show, url) {
      this.imgUrl = url;
      this.showHonor = show;
    },
    changeW() {
      if (judgeWindow()) {
        this.num = 1;
      } else {
        this.num = 3;
      }
    },
    changeName() {
      if (this.dom == 0) {
        this.item_name = "国家级荣誉";
        this.en_name = "National Honors";
      } else if (this.dom == 1) {
        this.item_name = "协会荣誉";
        this.en_name = "Association-level Honors";
      } else if (this.dom == 2) {
        this.item_name = "省级荣誉";
        this.en_name = "Provincial Honors";
      } else if (this.dom == 3) {
        this.item_name = "市级荣誉";
        this.en_name = "Municipal Honors";
      }
    },
    toggleLoadMore() {
      this.showAll = !this.showAll; // 切换展开和收起的状态
      this.$emit('showAll', true);
    },
  },
  /*   watch: {
    AwardsInfos: (val) => {
    },
  }, */

  mounted() {
    this.changeW();
    this.changeName();
    },
};
</script>

<style lang="scss" scoped>
.item_name {
  font-size: 2rem;
  padding-bottom: 2rem;
}
.slides {
  margin-top: -2rem;
  li {
    margin: 2rem 0;
    .item_left {
      .tit {
        font-size: 20px;
        font-weight: bold;
      }
      .desc {
        font-size: 16px;
        line-height: 1.3;
        margin-top: 0.5rem;
      }
    }
    .item_link {
      width: 6.5rem;
      cursor: pointer;
      height: 2.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #9b9b9b;
      border-radius: 2rem;
      &:hover {
        background: #c6322d;
        color: #fff;
        border-color: #c6322d;
      }
    }
  }
}

@media (max-width: 768px) {
  .slides li{
    margin:1.5rem 0;
  }
  .history .wrap {
    flex-direction: column;
    .sidebar {
      width: 100%;
      margin-bottom: 2rem;
    }
  }

  .honorTimeB {
    padding-left: 1rem;
  }
  .item_name {
    font-size: 1.4rem;
    margin-bottom: 1rem;
  }
  .slides li .item_link {
    width: 5rem;
    height: 2rem;
  }
}
</style>
